import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-797eef62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_user_settings_modal = _resolveComponent("user-settings-modal")!
  const _component_admin_modal = _resolveComponent("admin-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_toolbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_title, { slot: "start" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }),
        (!_ctx.isInternet)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, "No Internet Connection"))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_button, {
          slot: "end",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setMenu(true, $event)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_icon, {
              size: "large",
              icon: _ctx.menu
            }, null, 8, ["icon"])
          ]),
          _: 1
        }),
        _createVNode(_component_ion_popover, {
          "is-open": _ctx.menuOpen,
          event: _ctx.eventRef,
          onDidDismiss: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMenu(false)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_list, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_item, {
                  class: "menuItem",
                  button: "",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setUserModal(true)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      color: "secondary",
                      icon: _ctx.personOutline
                    }, null, 8, ["icon"]),
                    _createTextVNode(" User Settings")
                  ]),
                  _: 1
                }),
                (_ctx.isAdmin)
                  ? (_openBlock(), _createBlock(_component_ion_item, {
                      key: 0,
                      class: "menuItem",
                      button: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setAdminModal(true)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          color: "secondary",
                          icon: _ctx.constructOutline
                        }, null, 8, ["icon"]),
                        _createTextVNode(" Admin Operations ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _hoisted_2,
                _createVNode(_component_ion_item, {
                  class: "menuItem",
                  button: "",
                  onClick: _ctx.handleLogout
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      slot: "start",
                      color: "secondary",
                      icon: _ctx.logOutOutline
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Log out")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open", "event"])
      ]),
      _: 1
    }),
    _createVNode(_component_user_settings_modal, {
      isOpen: _ctx.userSettingsModal,
      onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setUserModal(false)))
    }, null, 8, ["isOpen"]),
    _createVNode(_component_admin_modal, {
      isOpen: _ctx.adminModal,
      onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setAdminModal(false)))
    }, null, 8, ["isOpen"])
  ], 64))
}